__turbopack_context__.v({
  "colourName": "ProductColourSelector-module-scss-module__vYGkzq__colourName",
  "container": "ProductColourSelector-module-scss-module__vYGkzq__container",
  "screenReader": "ProductColourSelector-module-scss-module__vYGkzq__screenReader",
  "singleColourName": "ProductColourSelector-module-scss-module__vYGkzq__singleColourName",
  "swatchButton": "ProductColourSelector-module-scss-module__vYGkzq__swatchButton",
  "swatchButtonColourNotAvailable": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonColourNotAvailable",
  "swatchButtonDisabled": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonDisabled",
  "swatchButtonHex": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonHex",
  "swatchButtonHexDisabled": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonHexDisabled",
  "swatchButtonImage": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonImage",
  "swatchButtonImageDisabled": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonImageDisabled",
  "swatchButtonSelected": "ProductColourSelector-module-scss-module__vYGkzq__swatchButtonSelected",
  "swatchGroupReduced": "ProductColourSelector-module-scss-module__vYGkzq__swatchGroupReduced",
  "swatchGroupTitle": "ProductColourSelector-module-scss-module__vYGkzq__swatchGroupTitle",
  "swatchList": "ProductColourSelector-module-scss-module__vYGkzq__swatchList",
});
